















































































import gql from 'graphql-tag';
import Vue from 'vue';

import { Client, Job } from '@/core/entity';
import OutletInput from '@/vue/components/input/Outlet.vue';

import { getClientCountryQL, getLastJobQL } from './graphql';

export default Vue.extend({
  components: {
    'input-outlet': OutletInput,
  },

  props: {
    clientId: String as () => string,
    loading: Boolean as () => boolean,
    projectId: String as () => string,
  },

  apollo: {
    client: {
      query: getClientCountryQL,
      variables() {
        return {
          clientId: this.clientId,
        };
      },
      skip() {
        return !this.clientId;
      },
      fetchPolicy: 'cache-first',
    },
    lastJob: {
      query: getLastJobQL,
      variables() {
        return {
          projectId: this.projectId,
        };
      },
      skip() {
        return !this.projectId;
      },
      fetchPolicy: 'cache-first',
    },
  },

  data() {
    return {
      client: undefined as Client | undefined,
      file: [] as File[],
      lastJob: undefined as Job | undefined,
      outlets: [] as string[],
      option: 'use_last' as 'use_last' | 'use_new',
    };
  },

  computed: {
    productCount(): number {
      if (this.lastJob) {
        return this.lastJob.products!.length;
      }
      return 0;
    },
  },

  methods: {
    beforeUpload(file: File) {
      this.file = [file];
      return false;
    },

    onBack(evt: Event) {
      evt.preventDefault();

      this.$emit('back');
    },

    onChange(val: string[]) {
      this.outlets = val;
    },

    onRemove(file: File) {
      this.file = [];
      return false;
    },

    validate(evt: Event) {
      evt.preventDefault();

      if (this.file.length === 0) {
        this.$emit('next', { lastJobId: this.lastJob!.id });
      } else {
        if (this.outlets.length === 0) {
          this.$message.error('Please select at least 1 outlet.');
          return;
        }

        this.$emit('next', { csv: this.file[0], outlets: this.outlets });
      }
    },
  },
});
